import useObservableValue from "../../../hooks/useObservableValue";
import hospitalSelectionState$, {
  initialHospitalSelectionState,
} from "../observables/hospitalSelectionState$";
import { SELECTED_HOSPITAL_STATE } from "../types/CommonTypes";

function useSelectedHospitalValue(): SELECTED_HOSPITAL_STATE {
  return useObservableValue(hospitalSelectionState$);
}

export default useSelectedHospitalValue;

export const getSelectedHospitalValue = (): SELECTED_HOSPITAL_STATE =>
  hospitalSelectionState$.getValue();

export const setSelectedHospitalValue = (info: SELECTED_HOSPITAL_STATE) =>
  hospitalSelectionState$.next(info);

export const updateSelectedHospitalValue = (
  info: Partial<SELECTED_HOSPITAL_STATE>
) => {
  const currentValue = getSelectedHospitalValue();
  hospitalSelectionState$.next({ ...currentValue, ...info });
};

export const resetSelectedHospitalValue = () =>
  hospitalSelectionState$.next(initialHospitalSelectionState);
